import calcFunctions from './calc';
import data from './data';

/*******************************************/

export function restart(delay = true) {
  // console.log('[RESTART]');

  data.state = 'new';
  this.setPlayClickDisable(true);
  setTimeout(init.bind(this), 0);
}

function init() {
  const exampleIdx = this.getState().exampleIdx;

  // init drawing for current example
  const calcInit = data.examples[exampleIdx].calcInit;
  this.setState({
    data: calcFunctions[calcInit](),
  });

  data.state = 'pause';
  this.changePlayState('pause');
  this.setPlayClickDisable(false);
}

/*******************************************/
// play clicked
export function play() {
  const temp = this.getState().playState;
  this.setState(state => ({
    playState: state.playState === 'play' ? 'pause' : 'play',
  }));
  data.state = 'in-play';
  if (temp === 'pause') {
    process.bind(this)();
  }
}

// step clicked
const go = (oldData, scale) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(calcFunctions.step(oldData, scale));
    }, 100);
  });
};

export async function step(scale) {
  if (this.getState().playState !== 'play') {
    this.setState({ busy: true });
  }

  const oldData = this.getState().data;

  const newData = await go(oldData, scale);
  if (oldData.data2DFirst === null) {
    newData.data2DFirst = JSON.parse(JSON.stringify(newData.data2D1));
  }
  this.setState(state => ({
    data: {
      ...state.data,
      ...newData,
    },
    busy: false,
    scale: scale,
  }));
  // this.setState({ scale: scale });
}

function process() {
  // console.log('[PROCESS]');

  const interval = data.examples[this.getState().exampleIdx].interval;

  // interval - time between each tick
  clearInterval(this.intervalID);
  this.intervalID = setInterval(newScale.bind(this), interval);

  function newScale() {
    const scale =
      this.getState().scale + data.examples[this.getState().exampleIdx].step;
    if (scale > data.examples[this.getState().exampleIdx].maxScale) {
      clearInterval(this.intervalID);
      this.changePlayState('pause');
    } else {
      if (data.state === 'new') {
        clearInterval(this.intervalID);
        this.changePlayState('pause');
        data.state = 'start';
        this.setState({ scale: scale });
      } else if (this.getState().playState === 'play') {
        // next scale
        step.bind(this)(scale);
      } else {
        clearInterval(this.intervalID);
        this.changePlayState('pause');
      }
    }
  }
}
